import { Link } from "react-router-dom";
import { BsFacebook, BsInstagram } from "react-icons/bs";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import logo from "../Images/SK_BLU.svg";

const navigationLinks = [
  { label: "Camping", path: "/camping" },
  { label: "Sahyadri Treks", path: "/SahyadriTreks" },
  { label: "Villas", path: "/villas" },
  { label: "Tour Packages", path: "/tour-packages" },
  { label: "Gallery", path: "/gallery" },
];

export function FooterPart() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-blue-900/10 bg-white text-slate-600">
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 sm:py-12 lg:px-8">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-[minmax(0,1.4fr)_minmax(0,0.9fr)_minmax(0,1fr)_minmax(0,1fr)] lg:gap-10">
          <div>
            <Link
              to="/"
              aria-label="SKAdventures home"
              className="inline-flex rounded-lg"
            >
              <img
                src={logo}
                alt="SKAdventures"
                className="h-10 w-auto"
              />
            </Link>
            <p className="mt-4 max-w-sm text-sm leading-6 text-slate-600">
              Discover lakeside camping and Sahyadri adventures with
              SKAdventures. Travelling is an investment in yourself.
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="https://www.instagram.com/_skadventures"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow SKAdventures on Instagram"
                className="rounded-full border border-slate-200 p-2.5 text-slate-600 transition hover:border-blue-200 hover:bg-blue-50 hover:text-blue-800"
              >
                <BsInstagram aria-hidden="true" className="h-4 w-4" />
              </a>
              <a
                href="https://www.facebook.com/skadventures91"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow SKAdventures on Facebook"
                className="rounded-full border border-slate-200 p-2.5 text-slate-600 transition hover:border-blue-200 hover:bg-blue-50 hover:text-blue-800"
              >
                <BsFacebook aria-hidden="true" className="h-4 w-4" />
              </a>
            </div>
          </div>

          <div>
            <h2 className="text-sm font-bold uppercase tracking-wide text-slate-900">
              Explore
            </h2>
            <ul className="mt-4 space-y-3">
              {navigationLinks.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-sm transition hover:text-blue-800 hover:underline hover:underline-offset-4"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="text-sm font-bold uppercase tracking-wide text-slate-900">
              Helpful links
            </h2>
            <ul className="mt-4 space-y-3">
              <li>
                <Link
                  to="/terms-and-conditions"
                  className="text-sm transition hover:text-blue-800 hover:underline hover:underline-offset-4"
                >
                  Terms &amp; Conditions
                </Link>
              </li>
              <li>
                <Link
                  to="/cancellation-policy"
                  className="text-sm transition hover:text-blue-800 hover:underline hover:underline-offset-4"
                >
                  Cancellation Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/camp-advisory"
                  className="text-sm transition hover:text-blue-800 hover:underline hover:underline-offset-4"
                >
                  Camp Advisory
                </Link>
              </li>
              <li>
                <Link
                  to="/trek-advisory"
                  className="text-sm transition hover:text-blue-800 hover:underline hover:underline-offset-4"
                >
                  Trek Advisory
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-sm font-bold uppercase tracking-wide text-slate-900">
              Need a hand?
            </h2>
            <p className="mt-4 text-sm leading-6">
              Contact our team for help with your next trip.
            </p>
            <div className="mt-4 space-y-3">
              <a
                href="https://wa.me/919371939191"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-sm font-semibold text-blue-800 transition hover:text-blue-950"
              >
                <FaWhatsapp aria-hidden="true" className="h-4 w-4" />
                Chat on WhatsApp
              </a>
              <a
                href="tel:+919371939191"
                className="flex items-center gap-2 text-sm font-semibold text-blue-800 transition hover:text-blue-950"
              >
                <FaPhoneAlt aria-hidden="true" className="h-3.5 w-3.5" />
                +91 93719 39191
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-2 border-t border-slate-200 pt-5 text-xs text-slate-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} SKAdventures. All rights reserved.</p>
          <p>Made for memorable journeys.</p>
        </div>
      </div>
    </footer>
  );
}
